export default [
    {
        path: '/account',
        name: 'AccountIndex',
        component: () => import ('./pages/Index')
    }
]